<template>
  <div>
    <NavBar/>
      <div class="content-container" style="margin-top:24px">
          <!-- 顶部 -->
          <el-row>
            <el-col :span="12">
              <el-card class="box-card  card1">
                <el-row>
                  <el-col :span="12">
                      <img src="@/assets/user_images/总投放.png" alt="" style="position: relative;top:-20px;">
                    <div style="display: inline-block;position: relative;top:-40px;margin-left:16px;padding:10px 40px 10px 0px;border-right:1px solid #fff">
                        <div class="num" style="display: in">{{total.allDeliveryTask?total.allDeliveryTask:0}}</div>
                        <div class="numTitle" style="margin-top:8px">总投放任务量</div>
                    </div>    
                  </el-col>
                  <el-col :span="6">
                      <div class="num">{{total.deliveryTask?total.deliveryTask:0}}</div>
                      <div class="numTitle">投放中任务量</div>
                  </el-col>
                  <el-col :span="6">
                      <div class="num">{{total.lastDeliveryTask?total.lastDeliveryTask:0}}</div>
                      <div class="numTitle">上月投放任务量</div>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="box-card card2" style="margin-left:24px">
                  <div>
                      <img src="@/assets/user_images/jie.png" alt="" >
                  </div>
                  <div class="num" style="margin-top:10px">{{moneyTrans(total.settledCommission)}}<span class="numTitle">元</span></div>
                  <div class="numDes" style="margin-top:6px;">已结算佣金</div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="box-card card3" style="margin-left:24px">
                  <div>
                      <img src="@/assets/user_images/dai.png" alt="" >
                  </div>
                  <div class="num" style="margin-top:10px">{{moneyTrans(total.pendingSettlementCommission)}}<span class="numTitle">元</span></div>
                  <div class="numDes" style="margin-top:6px;">待结算佣金</div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="box-card card4" style="margin-left:24px">
                  <div>
                      <img src="@/assets/user_images/gu.png" alt="" >
                  </div>
                  <div class="num" style="margin-top:10px">{{moneyTrans(total.estimatedCommissionThisMonth)}}<span class="numTitle">元</span></div>
                  <div class="numDes" style="margin-top:6px;">本月预估佣金（含税）</div>
              </el-card>
            </el-col>
          </el-row>
          <div style="margin-top:24px;background: #fff;padding:24px 40px 40px 40px">
            <div class='title' style="margin-bottom:24px">近半年投放任务量统计</div>
            <div style="height:600px;">
              <Statistics ref="lineData" />
            </div>
      
          </div>
        </div>
  </div>
  
</template>
<script>
  import Statistics from "@/components/charts/line"
  import NavBar from "@/components/navBar"
  import { statistics,taskTotal } from "@/api/dashboard.js"
  import { formatMoney } from '@/api/dataTrans.js'
  export default {
    components: {
      Statistics,
      NavBar
    },
    data(){
      return{
         total:{}
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        statistics().then(res => {

          if (res && res.code == 0) {
            if(res.data){
              res.data.reverse()
            }
            this.$refs.lineData.initData(this.dataTrans(res.data, "yearMonth", "missionNum"))
          }
        })
        taskTotal().then(res=>{
          if (res && res.code == 0) {
            this.total=res.data
          }
        })
      },
      moneyTrans(_val){
        return formatMoney(_val)
      },
      dataTrans(_arr, _attr1, _attr2) {
        var _result = { lableList: [], dataList: [] }
        _arr.forEach(items => {
          _result.lableList.push(items[_attr1])
          _result.dataList.push(items[_attr2])

        });
        _result.lableList.reverse()
        _result.dataList.reverse()
        return _result
      },

    },
  } 
</script>
<style scoped>
  .title {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 700;

  }

  .box-card {
    height: 180px;
    border-radius: 10px;
  }

  .card1 {
    background: linear-gradient(to right, #13C2C2 0%, #70E1F5 100%);
    padding: 50px 40px;
  }

  .card2 {
    text-align: center;
    background: linear-gradient(to right, #5C6BC0 0%, #C398F9 100%);
  }

  .card3 {
    background: linear-gradient(to right, #F69D30 0%, #F7C820 100%);
  }

  .card4 {
    background: linear-gradient(to right, #F03E44 0%, #F88080 100%);
  }
  .numTitle{
     font-size: 14px;
     color:#fff;
  }
  .num{
    font-size: 24px;
    color:#fff;
    font-weight: 700
  }
  .numDes{
    font-size: 12px;
    color:#fff;
  }
</style>